import { TileSizes } from '@ad-lucy/components/layout/Grid/TileSizeContext';
import type { GridInterface } from '@ad-lucy/context/adData/contentData/types';
import { BREAKPOINT_DISPLAY_NAME, BREAKPOINT_VALUE } from '@ad-lucy/grid-breakpoints';

import { defineGrid } from './defineGrid';

export const grid1x0x1 = (): GridInterface[] =>
  defineGrid('1:0:1', [
    {
      name: BREAKPOINT_DISPLAY_NAME.SITEBAR,
      breakpoint: BREAKPOINT_VALUE.SITEBAR,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              spanRow: 2,
              spanCol: 2,
            },
          ],
        },
        {
          columns: [
            {
              tileId: 1,
              spanCol: 2,
            },
          ],
        },
      ],
    },
    {
      name: BREAKPOINT_DISPLAY_NAME.HPA,
      breakpoint: BREAKPOINT_VALUE.HPA,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              spanRow: 2,
            },
          ],
        },
        {
          columns: [
            {
              tileId: 1,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
      ],
    },
    {
      name: BREAKPOINT_DISPLAY_NAME.MOBILE,
      breakpoint: BREAKPOINT_VALUE.MOBILE,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
        {
          columns: [
            {
              tileId: 1,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
      ],
    },
  ]);
